import { ACCESS_TYPES, PROFILES } from "./directory";

export const isUserMultiple = (state) => {
  const access = state.subscriberInfo.mode;
  const accessObj = typeof access === "string" ? ACCESS_TYPES[access] : access;

  return accessObj && accessObj.profilesAllowed === PROFILES.MULTIPLE;
};

export * from "./directory";
